import { createSelector } from '@reduxjs/toolkit';

import { COLLECTION_IDS } from '@/constants/collections';
import PAGES from '@/constants/pages';
import parametersSelector from '@/features/choice/selectors/parameters';
import configSelector from '@/features/config/selectors/config';
import { RootStateType } from '@/features/store';

import getCarsParameters from '../helpers/getCarsParameters';
import { CarsParametersType } from '../types';

const carsParametersSelector = createSelector(
  [
    configSelector,
    parametersSelector,
    (_: RootStateType, offset?: number) => offset ?? 0,
  ],
  (config, parameters, offset) => {
    const { spaceId, envId } = config;

    const carsParameters: CarsParametersType = {
      ...parameters,
      spaceId,
      envId,
      collectionId: COLLECTION_IDS.vehiclesVehicles,
      options: {
        ...parameters?.options,
        options: {
          ...parameters.options.options,
          offset,
        },
      },
    };

    return getCarsParameters(carsParameters, config, PAGES.Cars);
  },
);

export default carsParametersSelector;
